/**
 * Fades routed page content under the persistent HudHeader shell.
 * `mode="wait"` ensures the outgoing route unmounts before the next
 * mounts — sync crossfades were stacking two heavy views (smoke canvas,
 * SVG rings) and reading as jitter / ghosted content.
 */

import { AnimatePresence, motion, useReducedMotion } from "motion/react";
import { Outlet, useLocation } from "react-router-dom";
import { pageTransition, pageTransitionReduced } from "@/lib/motion";

export function PageTransition() {
  const { pathname } = useLocation();
  const reduceMotion = useReducedMotion();
  const variants = reduceMotion ? pageTransitionReduced : pageTransition;

  return (
    <div className="h-full">
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={pathname}
          className="h-full overflow-hidden"
          initial={variants.initial}
          animate={variants.animate}
          exit={variants.exit}
        >
          <Outlet />
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
